import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0d47a1",
      d: "M42 24.649V11.784C23.741 18.92 17.065 24.368 18.881 41.55c.09.85.596 1.613 1.371 1.973 1.442.668 2.742 1.035 3.748 1.035 5.143 0 18-9.606 18-19.909"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1e88e5",
      d: "M24 4.042c3.461 0 10.416 1.75 14.595 2.895q.587.162 1.094.308C41.078 7.647 42 8.932 42 10.379v2.128c-.413 9.479-3.45 12.236-11.928 19.062-1.113.985-2.258 1.923-3.42 2.874-1.665 1.363-3.365 2.756-5.062 4.362a3.365 3.365 0 0 0 1.141 5.597 10 10 0 0 1-.982-.277c-3.101-1.039-7.286-3.87-10.563-7.63C8.603 20.397 13.667 12.507 24 4.042"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#80d8ff",
      d: "M8.409 7.212C12.383 6.1 20.246 4.042 24 4.042q.406 0 .872.032a6.774 6.774 0 0 1 5.146 10.233c-1.314 2.619-3.465 4.677-6.738 7.372-.94.774-2.018 1.628-3.093 2.48a230 230 0 0 0-2.919 2.338c-2.164 1.774-3.486 2.858-4.214 4.219a6.75 6.75 0 0 0-1.095 3.694c0 1.995.863 3.788 2.235 5.028q.066.074.132.143l.035.053a32 32 0 0 1-1.29-1.167C9.214 34.778 6 29.8 6 24.648V10.414c0-1.491.973-2.8 2.409-3.202"
    }, null, -1)
  ]))]))
}
export default { render: render }